import ApiService from "../../_services/ApiService";

export const updateProductImages = async ({ barterId, productImageUrls, imageIds }) => {
  if (!barterId || !productImageUrls?.length || !imageIds?.length) return;

  const payload = {
    barter: barterId,
    product_images: productImageUrls.map((url) => ({
      url,
    //   path: url 
    }))
  };

  const searchParams = `ids=${imageIds.join(",")}`;

  return await ApiService.put("product_images", payload, searchParams);
};

